module.exports = __webpack_public_path__ + "static/media/caret-left-new.a7b92373.svg";